import { axiosClient } from '../../../library/Service/axiosClient';
import PageConfigMyEnquiries from './PageConfigMyEnquiries.json';

class MyEnquiriesService {
    static normalizeInquiry(inquiry: any) {
        return {
            ...inquiry,
            createdAt: inquiry?.createdAt ?? inquiry?.created_at ?? null,
            respondedAt: inquiry?.respondedAt ?? inquiry?.responded_at ?? null,
            viewedAt: inquiry?.viewedAt ?? inquiry?.viewed_at ?? null,
            responseMessage: inquiry?.responseMessage ?? inquiry?.response_message ?? '',
            lastMessage: inquiry?.lastMessage ?? inquiry?.last_message ?? inquiry?.responseMessage ?? inquiry?.response_message ?? inquiry?.message ?? '',
            outcome: inquiry?.outcome ?? 'PENDING',
            providerId: inquiry?.providerId ?? inquiry?.provider_id ?? null,
            businessName: inquiry?.businessName ?? inquiry?.business_name ?? '',
            providerName: inquiry?.providerName ?? inquiry?.provider_name ?? '',
            providerEmail: inquiry?.providerEmail ?? inquiry?.provider_email ?? '',
            providerPhone: inquiry?.providerPhone ?? inquiry?.provider_phone ?? '',
            providerImagePath: inquiry?.providerImagePath ?? inquiry?.provider_image_path ?? '',
            providerProgramName: inquiry?.providerProgramName ?? inquiry?.provider_program_name ?? '',
            providerPassOutYear: inquiry?.providerPassOutYear ?? inquiry?.provider_pass_out_year ?? '',
            availabilityStatus: inquiry?.availabilityStatus ?? inquiry?.availability_status ?? '',
            websiteUrl: inquiry?.websiteUrl ?? inquiry?.website_url ?? '',
            categoryCode: inquiry?.categoryCode ?? inquiry?.category_code ?? '',
            subcategoryCode: inquiry?.subcategoryCode ?? inquiry?.subcategory_code ?? '',
        };
    }

    static pageLoader(params: any): Promise<any> {
        return this.getMyEnquiries()
            .then((response) => {
                const payload = response?.data ?? {};
                const inquiryList = Array.isArray(payload?.data)
                    ? payload.data.map((item: any) => this.normalizeInquiry(item))
                    : [];

                return {
                    formConfig: PageConfigMyEnquiries,
                    data: {
                        inquiryList,
                        pagination: {
                            total: payload?.total ?? 0,
                            page: 1,
                            limit: payload?.total ?? 0,
                        },
                    },
                    routeInfo: params,
                    internal: { gridState: {} },
                };
            })
            .catch((error) => {
                console.error('Error loading My Enquiries:', error);
                return {
                    formConfig: PageConfigMyEnquiries,
                    data: {
                        inquiryList: [],
                        pagination: { total: 0, page: 1, limit: 0 },
                    },
                    routeInfo: params,
                    internal: { gridState: {} },
                };
            });
    }

    static getMyEnquiries() {
        return axiosClient().get(`${process.env.REACT_APP_COMMON_API}/provider-inquiries/my-enquiries`);
    }

    static async getMyEnquiryById(inquiryId: string | number) {
        const response = await this.getMyEnquiries();
        const records = Array.isArray(response?.data?.data) ? response.data.data : [];
        const inquiry = records.find((item: any) => `${item?.id}` === `${inquiryId}`);

        return inquiry ? this.normalizeInquiry(inquiry) : null;
    }

    static getMessages(inquiryId: string | number) {
        return axiosClient().get(`${process.env.REACT_APP_COMMON_API}/provider-inquiries/${inquiryId}/messages`);
    }

    static sendMessage(inquiryId: string | number, payload: { message: string }) {
        return axiosClient().post(`${process.env.REACT_APP_COMMON_API}/provider-inquiries/${inquiryId}/message`, payload);
    }
}

export default MyEnquiriesService;